import React, { PropTypes } from 'react';
import assign from 'object.assign';
import Page from 'components/Page';
import Content from 'components/Content';
import Column from 'components/Content/Column';
import Pattern from 'components/Pattern';
import PureComponent from 'components/PureComponent';
import Socials from 'components/Socials';
import Bottle from 'components/Bottle';
import Footer from 'components/Footer';
import WaveLink from 'components/WaveLink';
import DocumentTitle from 'react-document-title';
import checkMobile from 'utils/checkMobile';

class Faq extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  render() {
    require('./Faq.styl');

    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);
    const pageProps = {
      style: {
        backgroundImage: isMobile ? '' : `url(${this.props.backgroundImage[0]})`
      }
    };

    return (
      <Page {...pageProps}>
        <DocumentTitle title="Задать вопрос — Глубинная байкальская вода BAIKAL430" />

        {!isMobile && [
          <Pattern
            key="1"
            left="80%"
            colorLeft="#1AAFEF"
            colorRight="transparent"
          />,
          <Pattern key="2" left="80%" colorLeft="transparent" />
        ]}

        <Content reverse={isMobile}>
          <Column style={{ textAlign: 'center', paddingBottom: 80 }}>
            <div className="Faq__poem">
              <h2>Байкал</h2>
              <p>
                Я с детства мечтал о Байкале,
                <br />
                И вот — я увидел Байкал.
                <br />
                Мы плыли, и гребни мелькали,
                <br />И кедры смотрели со скал.
              </p>
              <p>
                Я множество разных историй
                <br />
                И песен тогда вспоминал
                <br />
                Про это озёрное море,
                <br />
                Про этот священный Байкал.
              </p>
              <p>
                От пристани к пристани плыли.
                <br />
                Был вечер. Был холод. Был май.
                <br />
                Был поезд, — и мы укатили
                <br />В том поезде в синий Китай.
              </p>
              <p>
                Как часто душа иссякала
                <br />
                В желанье вернуться опять.
                <br />
                Я так и не знаю Байкала:
                <br />
                Увидеть — не значит узнать.
              </p>

              <p>
                <strong
                  style={{
                    fontFamily:
                      "'Promixa Nova Condensed', Helvertica, Arial, sans-serif",
                    textTransform: 'uppercase',
                    fontSize: 17
                  }}
                >
                  Игорь Северянин, 1929 г.
                </strong>
              </p>
            </div>
          </Column>

          {isMobile && (
            <Column
              className="Content__column--bottle"
              style={{
                backgroundImage: `url(${this.props.backgroundImage[0]})`
              }}
            >
              <Bottle cover={this.props.backgroundImage[1]} />
            </Column>
          )}

          <Column style={{ textAlign: 'center', paddingBottom: 50 }}>
            <div className="Faq__contacts">
              <div className="Faq__contact Faq__contact--email">
                <h4>ЗАДАТЬ ВОПРОС ПО ПОЧТЕ</h4>
                <WaveLink href="mailto:info@baikal-sea.com" color="#FFF">
                  info@baikal-sea.com
                </WaveLink>
              </div>
              <div className="Faq__contact Faq__contact--phone">
                <h4>ПОЗВОНИТЬ НА ГОРЯЧУЮ ЛИНИЮ</h4>
                <a href="tel:+7(800)3331616">8 (800) 333-16-16</a>
              </div>
            </div>
          </Column>
        </Content>

        <div className="Page__socials">
          <Socials light />
        </div>

        {/* {isMobile && (
          <div className="Faq__footer">
            <Footer />
          </div>
        )} */}
      </Page>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/pages/Faq/Faq.js